<template>
  <div>
    <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
      <ls-card>
        <template #title>基础信息</template>
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="流程单号">
              <a-input v-model="detail.billNo" disabled />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="流程名称">
              <a-input v-model="detail.formName" disabled />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="申请人">
              <a-input v-model="detail.realName" disabled />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="申请时间">
              <a-input v-model="detail.applyTime" disabled />
            </a-form-item>
          </a-col>
        </a-row>
      </ls-card>
      <ls-card>
        <template #title>详细信息</template>
        <ls-api-table ref="dataTable" :columns="columns" :tableProps="tableProps" rowKey="serialNumber"
                      :scroll="{ x: 2500, y: 200 }">
          <template v-for="item in columns">
            <div :slot="item.dataIndex" slot-scope="{ text }" :key="item.dataIndex">
              <span v-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
      </ls-card>
      <ls-card>
        <template #title>审批</template>
        <a-row>
          <a-col :md="24" :sm="24">
            <a-button type="primary" :disabled="detail.statusName === '已批准' || detail.statusName === '已拒绝'"
                      :loading="approvalLoading" @click="handleRatify">批准</a-button>
            <a-button type="primary" :disabled="detail.statusName === '已批准' || detail.statusName === '已拒绝'"
                      :loading="rejectLoading" class="ml10" @click="handleRefuse">拒绝</a-button>
          </a-col>
          <a-col :md="24" :sm="24" class="mt10 mb10 approval-input">
            <a-form-item label="审批意见" :labelCol="{ style: { width: '150px' } }">
              <a-input v-model="detail.comment" :disabled="detail.statusName === '已批准' || detail.statusName === '已拒绝'" />
            </a-form-item>
          </a-col>
        </a-row>
      </ls-card>
    </a-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { apiKernelFlowExternalBpm, apiMesFlowOrderApprovalHeader, apiMesFlowPathLineWmsApprovalList } from '@/api/approval/approval-process'
import { generateLsTableResData } from '@/utils/util.js';
import md5 from 'md5'
export default {
  // eslint-disable-next-line
  name: 'approval-inventory-adjectment', // name要和菜单路由保存一致
  components: {},
  data () {
    return {
      detail: {
        billNo: "",
        formName: "",
        realName: "",
        applyTime: "",
        comment: ""
      },
      tableProps: {
        requestApi: generateLsTableResData(apiMesFlowPathLineWmsApprovalList, true),
        pageCurrent: true
      },
      queryParams: {},
      columns: [
        {
          title: '子库',
          dataIndex: 'tenantid',
          align: 'center',
          ellipsis: true
        },
        {
          title: '调整单号',
          dataIndex: 'adjustmentkey',
          align: 'center',
          ellipsis: true
        },
        {
          title: '行号',
          dataIndex: 'adjustmentline',
          align: 'center',
          ellipsis: true
        },
        {
          title: '采购类型',
          dataIndex: 'cgtype',
          align: 'center',
          ellipsis: true
        },
        {
          title: '货品',
          dataIndex: 'skukey',
          align: 'center',
          ellipsis: true
        },
        {
          title: '货品描述',
          dataIndex: 'wlmc',
          align: 'center',
          ellipsis: true
        },
        {
          title: '库位',
          dataIndex: 'lockey',
          align: 'center',
          ellipsis: true
        },
        {
          title: 'ID',
          dataIndex: 'id',
          align: 'center',
          ellipsis: true
        },
        {
          title: '调整数量',
          dataIndex: 'qty',
          align: 'center',
          ellipsis: true
        },
        {
          title: '计量单位',
          dataIndex: 'unit',
          align: 'center',
          ellipsis: true
        },
        {
          title: '调整原因',
          dataIndex: 'reasonkey',
          align: 'center',
          ellipsis: true
        },
        {
          title: '创建人',
          dataIndex: 'addwho',
          align: 'center',
          ellipsis: true
        },
        {
          title: '创建日期',
          dataIndex: 'adddate',
          scopedSlots: { customRender: 'adddate' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '修改人',
          dataIndex: 'editwho',
          align: 'center',
          ellipsis: true
        },
        {
          title: '修改日期',
          dataIndex: 'editdate',
          scopedSlots: { customRender: 'editdate' },
          width: 170,
          align: 'center',
          type: "text"
        }
      ],
      detailPrevious: null,
      approvalLoading: false,
      rejectLoading: false
    }
  },
  beforeRouteEnter (to, from, next) {
    to.meta.title = '盘点调整单审批'
    next();
  },
  computed: {
    ...mapState({
      jobCode: (state) => state.user.jobCode
    })
  },
  created () {
    this.headId = this.$route.query.bpmBillNo
    apiMesFlowOrderApprovalHeader({ headId: this.headId }).then(res => {
      console.log(res)
      this.detail = res.data
      this.queryParams.headId = this.detail && this.detail.billNo || null
      this.onSearch()
    })

    // const row = JSON.parse(this.$route.query.row)
    // this.detailPrevious = JSON.parse(JSON.stringify(row))
    // row.applyTime = this.$moment(row.applyTime).format('YYYY-MM-DD HH:mm:ss')
    // this.detail = row
  },
  mounted () {

  },
  methods: {
    examineAndApprove (val) {
      const apiKey = process.env.VUE_APP_API_SCM_GYL_URL_api_key
      const apiSecret = process.env.VUE_APP_API_SCM_GYL_URL_api_secret
      const timestamp = new Date().getTime()
      const sign = md5(apiKey.toString() + timestamp.toString() + apiSecret.toString());
      const url = `${process.env.VUE_APP_API_SCM_GYL_URL}/api/kernel-flow/external/bpm/approveProcess?apiKey=${apiKey}&apiSecret=${apiSecret}&timestamp=${timestamp}&sign=${sign}`
      const params = {
        assignee: this.jobCode, // 当前登陆用户
        billNo: this.detail.billNo, // 单号
        processCode: this.detail.processCoding, // 流程编码
        variables: {
          billRowId: this.detail.id, // id
          comment: this.detail.comment || "",
          status: val // 审批状态
        }
      }
      apiKernelFlowExternalBpm(url, params).then(res => {
        if (val === "APPROVED" && res.state === 100) {
          this.$message.success("批准成功")
          setTimeout(() => {
            this.approvalLoading = false
            this.handleClose()
          }, 2000)
        } else if (val === "REJECTED" && res.state === 100) {
          this.$message.success("拒绝成功")
          setTimeout(() => {
            this.rejectLoading = false
            this.handleClose()
          }, 2000)
        } else {
          this.$message.error(res.msg)
          this.approvalLoading = false
          this.rejectLoading = false
        }
      }).catch(e => {
        this.approvalLoading = false
        this.rejectLoading = false
      })
    },
    requestRefuse () {
      const url = `${process.env.VUE_APP_API_WMS_URL}/raptor-wms-single/inventory/terminate`
      const params = {
        billNo: this.detail.billNo, // 单号
        approvalComments: this.detail.comment || "",
        status: "REJECTED",
        user: this.jobCode // 当前登陆用户
      }
      apiKernelFlowExternalBpm(url, params).then(res => {
        if (res.success) {
          this.$message.success("拒绝成功")
          setTimeout(() => {
            this.handleClose()
          }, 2000)
        } else {
          this.$message.error(res.msg)
        }
        this.rejectLoading = false
      }).catch(e => {
        const res = e.response.data
        this.$message.error(res.msg)
        this.rejectLoading = false
      })
    },
    // 批准
    handleRatify () {
      this.approvalLoading = true
      this.examineAndApprove("APPROVED")
    },
    // 拒绝
    handleRefuse () {
      this.rejectLoading = true
      this.requestRefuse()
    },
    // 表单搜索
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    handleClose () {
      this.event.$emit("close-current-page");
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select {
  width: 170px;
}

input {
  width: 170px;
}

/deep/.ant-input-number {
  width: 170px;
}

/deep/.ant-calendar-picker {
  width: 150px;
}

.approval-input {
  input {
    width: 400px;
  }
}
</style>
